import { filterValueToUrlString } from '@features/table/utils/tableFilterValueParse.util';
import type { ColumnFilter } from '@tanstack/react-table';

const createFilterQueryString = (filters: ColumnFilter[]) => {
  const params = new URLSearchParams();

  filters.map(({ id, value }, index) => {
    const filterString = filterValueToUrlString(value);

    if (id && filterString) {
      params.append(`filter[${index.toString()}][filterBy]`, id);
      params.append(`filter[${index.toString()}][filterString]`, filterString);
    }
  });

  return params.toString();
};

export { createFilterQueryString };
